function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Row, Col } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import _ from 'underscore';
import entityComposition from '../common/classes/entityComposition';
import SingleOtherPicker from '../common/controls/singleOtherPicker';
import SinglePicker from '../common/controls/singlePicker';
const determineAssetCategories = assetType => {
  const assetCategoriesObject = {};
  (assetType.list || []).forEach(({
    categoryName
  }) => {
    if (!assetCategoriesObject[categoryName]) {
      assetCategoriesObject[categoryName] = {
        id: categoryName,
        name: categoryName
      };
    }
  });
  const assetCategories = Object.values(assetCategoriesObject) || [];
  assetCategories.push({
    id: 'Other',
    name: 'Other'
  });
  return assetCategories;
};
const determineAssetTypeOptions = (assetType, selectedCategory) => {
  // there are no asset type options if there are no asset types AND if category is Other
  if (selectedCategory !== 'Other' && assetType && assetType.list && assetType.list.length) {
    const typesByCategoryName = _.groupBy(assetType.list, 'categoryName');
    const typesOptionsForSelectedCategory = typesByCategoryName[selectedCategory] || [];
    return typesOptionsForSelectedCategory;
  }
  return [];
};
const determineSelectedAssetTypeCategory = (assetType, assetTypeID, otherAssetCategory) => {
  if (otherAssetCategory) {
    return otherAssetCategory; // this means `Other` category is selected
  }
  if (assetTypeID) {
    const foundAssetType = (assetType.list || []).find(next => next.id === assetTypeID);
    return foundAssetType && foundAssetType.categoryName ? foundAssetType.categoryName : null;
  }
  return null;
};
class AssetGeneralCategoryType extends Component {
  constructor(props) {
    super(props);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
  }
  componentDidMount() {
    const {
      assetType,
      assetTypeActions,
      assetTypeOther,
      assetTypeOtherActions
    } = this.props;
    assetTypeActions.serverIndex(assetType.indexQuery);
    assetTypeOtherActions.serverIndex(_objectSpread(_objectSpread({}, assetTypeOther.indexQuery), {}, {
      /* always get most up to date list, otherwise this will miss new entries created by asset save
       *
       * note: if we ever see a bug where type === other, but category !== other but category
       *       shows other, move index query initialized: false to componentWillUnmount
       *
       * also: this query is grabbing ALL assetTypeOthers... Not just the one joined to this asset
       *       there's an investigation ticket to see if we can avoid having to do this in the
       *       future: https://www.pivotaltracker.com/story/show/161231004
       */
      initialized: false
    }));
  }
  handleCategoryChange(newCategory) {
    const {
      assetChange
    } = this.props;
    // Clear everything out on a category change
    assetChange('assetTypeID', null);
    assetChange('typeName', null);
    assetChange('assetTypeOtherID', null);
    assetChange('categoryName', newCategory);
  }
  handleTypeChange(assetTypeCategoryName, value) {
    const {
      assetChange
    } = this.props;
    let validValue = ''; // validator requires a string and throws error on null
    if (value !== null) {
      validValue = value;
    }
    if (validator.isUUID(validValue)) {
      assetChange('assetTypeID', validValue);
      assetChange('assetTypeOtherID', null);
      assetChange('categoryName', assetTypeCategoryName);
    } else {
      assetChange('assetTypeID', null);
      assetChange('assetTypeOtherID', null);
      assetChange('categoryName', assetTypeCategoryName);
      assetChange('typeName', validValue);
    }
  }
  render() {
    const {
      asset,
      assetType,
      assetTypeOther
    } = this.props;
    const {
      assetTypeID,
      assetTypeOtherID,
      typeName
    } = asset;
    let assetTypeCategoryName = '';
    if (assetTypeOtherID && assetTypeOther && assetTypeOther.list && assetTypeOther.list.length) {
      // retrieve the `other` asset type
      const selectedAssetTypeOther = assetTypeOther.list.find(n => n.id === assetTypeOtherID);
      // Default to Other category name if empty (iPad leaves categoryName empty for category=other)
      if (
      // if loading right after other creation, this is null until new server index returns
      selectedAssetTypeOther && selectedAssetTypeOther.categoryName // we save as null
      && selectedAssetTypeOther.categoryName.length !== 0 // ipad saves as empty string
      ) {
        assetTypeCategoryName = selectedAssetTypeOther.categoryName;
      } else {
        assetTypeCategoryName = 'Other';
      }
    } else {
      // sort thru the asset types and determine what the selected asset type category name is
      assetTypeCategoryName = determineSelectedAssetTypeCategory(assetType, assetTypeID, asset.categoryName);
    }

    // determine all potential asset categories from available asset types
    const assetTypeCategoryOptions = determineAssetCategories(assetType);
    // create a list of all asset types with the same categoryName (0 or many)
    const assetTypeOptions = determineAssetTypeOptions(assetType, assetTypeCategoryName);
    return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SinglePicker, {
      label: "Category",
      labelKey: "name",
      onChange: this.handleCategoryChange,
      options: assetTypeCategoryOptions,
      placeholder: "Select...",
      value: assetTypeCategoryName,
      returnValueKey: "name",
      searchable: false
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 6
    }, /*#__PURE__*/React.createElement(SingleOtherPicker, {
      label: "Type",
      labelKey: "name",
      onChange: value => this.handleTypeChange(assetTypeCategoryName, value),
      options: assetTypeOptions,
      returnValueKey: "id",
      value: assetTypeID || typeName,
      placeholder: assetTypeCategoryName ? 'Select or create a type...' : 'First select a category...',
      disabled: !assetTypeCategoryName
    })));
  }
}
AssetGeneralCategoryType.propTypes = {
  asset: PropTypes.shape({
    assetTypeID: PropTypes.string,
    typeName: PropTypes.string,
    categoryName: PropTypes.string,
    assetTypeOtherID: PropTypes.string
  }).isRequired,
  assetType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetTypeOther: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetTypeOtherActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  assetChange: PropTypes.func.isRequired
};
export { AssetGeneralCategoryType as TestAssetGeneralCategoryType };
export default entityComposition(AssetGeneralCategoryType, ['assetType', 'assetTypeOther'] // assetTypeOther could be a custom query with the assetID
);